// extracted by mini-css-extract-plugin
export var actionButton = "_me-0";
export var actionMenuContainer = "_me-i";
export var bubble = "_me-2";
export var bubbleActionMenu = "_me-j";
export var bubbleContext = "_me-6";
export var bubbleItems = "_me-7";
export var customer = "_me-3";
export var divider = "_me-8";
export var fileList = "_me-9";
export var hiddenComment = "_me-o";
export var infoAbove = "_me-a";
export var internal = "_me-4";
export var lightActionButton = "_me-1";
export var link = "_me-b";
export var merchant = "_me-5";
export var message = "_me-c";
export var profilePicture = "_me-e";
export var quillToolbarContainer = "_me-f";
export var senderDate = "_me-g";
export var senderDateCustomer = "_me-h";
export var senderName = "_me-d";
export var time = "_me-k";
export var uploadedImage = "_me-l";
export var username = "_me-m";
export var xsmall = "_me-n";